import builder from '@builder.io/react';

export async function fetchCMSData(modelName, query = {}) {
  const { data } = await builder.get(modelName, query);

  return data;
}

export async function getAllCMSData(modelName, query = {}) {
  const data = await builder.getAll(modelName, query);

  return data;
}
